var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9074_18732",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.600098,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9074_18732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1001 14.3958C5.87788 13.7569 6.73899 13.2812 7.68343 12.9688C8.62788 12.6562 9.6001 12.5 10.6001 12.5C11.6001 12.5 12.5723 12.6528 13.5168 12.9583C14.4612 13.2639 15.3223 13.7431 16.1001 14.3958V4.5H5.1001V14.3958ZM10.6051 11.5C11.4351 11.5 12.1418 11.2067 12.7251 10.62C13.3084 10.0333 13.6001 9.325 13.6001 8.495C13.6001 7.665 13.3068 6.95833 12.7201 6.375C12.1334 5.79167 11.4251 5.5 10.5951 5.5C9.7651 5.5 9.05843 5.79333 8.4751 6.38C7.89176 6.96667 7.6001 7.675 7.6001 8.505C7.6001 9.335 7.89343 10.0417 8.4801 10.625C9.06676 11.2083 9.7751 11.5 10.6051 11.5ZM5.1001 17C4.6876 17 4.33447 16.8531 4.04072 16.5594C3.74697 16.2656 3.6001 15.9125 3.6001 15.5V4.5C3.6001 4.0875 3.74697 3.73438 4.04072 3.44063C4.33447 3.14688 4.6876 3 5.1001 3H16.1001C16.5126 3 16.8657 3.14688 17.1595 3.44063C17.4532 3.73438 17.6001 4.0875 17.6001 4.5V15.5C17.6001 15.9125 17.4532 16.2656 17.1595 16.5594C16.8657 16.8531 16.5126 17 16.1001 17H5.1001ZM6.12093 15.5H15.0793C14.4404 15.0139 13.739 14.6424 12.9751 14.3854C12.2112 14.1285 11.4195 14 10.6001 14C9.78065 14 8.99246 14.1285 8.23551 14.3854C7.47857 14.6424 6.77371 15.0139 6.12093 15.5ZM10.6001 10C10.1834 10 9.82926 9.85417 9.5376 9.5625C9.24593 9.27083 9.1001 8.91667 9.1001 8.5C9.1001 8.08333 9.24593 7.72917 9.5376 7.4375C9.82926 7.14583 10.1834 7 10.6001 7C11.0168 7 11.3709 7.14583 11.6626 7.4375C11.9543 7.72917 12.1001 8.08333 12.1001 8.5C12.1001 8.91667 11.9543 9.27083 11.6626 9.5625C11.3709 9.85417 11.0168 10 10.6001 10Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBox);
export default __webpack_public_path__ + "static/media/account_box.8be7eba6cb38552ffd1fb5b0e21120d5.svg";
export { ForwardRef as ReactComponent };